module.exports = __webpack_public_path__ + "img/icon_tijiao.28a9cc35.svg";